<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 p-0 footer-left">
          <p class="mb-0">Copyright © 2025 Super Kompras. Todos los derechos reservados.</p>
        </div>
        <div class="col-md-6 p-0 footer-right">
          <p class="mb-0">
            Desarrollado por <a href="https://www.cideapps.com" target="_blank">CIDEAPPS</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
